import React from 'react';
import { Link } from "react-router-dom";
const Error500 = (props) => {			
    return(
	<>
	{/*<!-- SECTION CONTENT START --> */}
	<div className="section-full p-t80 p-b50">            
		<div className="container">
			<div className="section-content">
				<div className="page-notfound-wrap row">
				
					<div className="col-lg-8 col-md-6 col-sm-6">
						<div className="page-notfound text-center">
							<form method="post">
								<strong className="text-uppercase">Error 404:</strong>
								<strong>PAGE NOT FOUND<i className="fa fa-frown-o site-text-primary"></i><i className="fa fa-frown-o site-text-primary"></i></strong>
								<span>Internal Error</span>
								<Link to="/" className="site-button ">GO TO HOME  <i className="fa fa-angle-double-right"></i></Link>
							</form>
						</div>
					</div>
					
					<div className="col-lg-4 col-md-6 col-sm-6">
						<div className="page-notfound-left text-center bg-gray">
							<div className="constrot-strip"></div>
							<span className="flaticon-bath-salt-bomb"></span>
							<div className="constrot-strip"></div>
						</div>
					</div>
					
				</div>
			</div>
		</div>
		
	</div>
	{/*<!-- SECTION CONTENT END -->	*/}		
    </>
    )
}
export default Error500;